/*!
 * jQuery Cookie Plugin v1.4.0
 */
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else {
        factory(jQuery);
    }
}(function ($) {
    var pluses = /\+/g;
    function encode(s) { return config.raw ? s : encodeURIComponent(s); }
    function decode(s) { return config.raw ? s : decodeURIComponent(s); }
    function stringifyCookieValue(value) {
        return encode(config.json ? JSON.stringify(value) : String(value));
    }
    function parseCookieValue(s) {
        if (s.indexOf('"') === 0) {
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        }
        try {
            s = decodeURIComponent(s.replace(pluses, ' '));
            return config.json ? JSON.parse(s) : s;
        } catch (e) {}
    }
    function read(s, converter) {
        var value = config.raw ? s : parseCookieValue(s);
        return $.isFunction(converter) ? converter(value) : value;
    }

    var config = $.cookie = function (key, value, options) {
        if (value !== undefined && !$.isFunction(value)) {
            options = $.extend({}, config.defaults, options);
            if (typeof options.expires === 'number') {
                var days = options.expires, t = options.expires = new Date();
                t.setTime(+t + days * 864e+5);
            }
            return (document.cookie = [
                encode(key), '=', stringifyCookieValue(value),
                options.expires ? '; expires=' + options.expires.toUTCString() : '',
                options.path ? '; path=' + options.path : '',
                options.domain ? '; domain=' + options.domain : '',
                options.secure ? '; secure' : ''
            ].join(''));
        }

        var result = key ? undefined : {};
        var cookies = document.cookie ? document.cookie.split('; ') : [];

        for (var i = 0, l = cookies.length; i < l; i++) {
            var parts = cookies[i].split('=');
            var name = decode(parts.shift());
            var cookie = parts.join('=');

            if (key && key === name) {
                result = read(cookie, value);
                break;
            }

            if (!key && (cookie = read(cookie)) !== undefined) {
                result[name] = cookie;
            }
        }

        return result;
    };

    config.defaults = {};

    $.removeCookie = function (key, options) {
        if ($.cookie(key) === undefined) {
            return false;
        }
        $.cookie(key, '', $.extend({}, options, { expires: -1 }));
        return !$.cookie(key);
    };
}));
$(document).ready(function () {
    var $wheelify = $('#wheelify-spin_a_sale_cc_store_front_module');
    var $signupPopup = $('#signup-popup-onload');
    if ($wheelify.length && $wheelify.is(':visible')) {
        $signupPopup.hide();
        return;
    } else {
        $signupPopup.show();
    }
    if (!$.cookie('popupShown')) {
      $(document).ready(function () {
            setTimeout(function () {
                if ($wheelify.length && $wheelify.is(':visible')) {
                    return;
                }
                $.magnificPopup.open({
                    items: {
                        src: '#popup-onload'
                    },
                    type: 'inline',
                    closeBtnInside: true,
                    mainClass: 'mfp-fade'
                });
                $.cookie('popupShown', 'yes');
            }, 30000);
        });
    }
});